import $ from 'jquery';

export default function onboardingModule() {
  const onboardingElement = $('.js-datepicker, .onboarding');
  if (onboardingElement.length) {
    return import(/* webpackChunkName: "Onboarding" */ '../onboarding')
      .then(({ default: Onboarding }) => {
        const onboarding = new Onboarding();
        return onboarding;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
